/* In-place recipe collection navigation; regular links remain the no-script fallback. */
(() => {
  if(window.NanaRecipeNavigation)return;
  window.NanaRecipeNavigation=true;
  const collections=new Set(['family','restaurant','tapas','desserts']);
  const view=url=>{const value=url.searchParams.get('view')||'';return value.startsWith('nana-')&&collections.has(value.slice(5))?value.slice(5):null;};
  const loadedScripts=new Set([...document.scripts].filter(s=>s.src).map(s=>new URL(s.src).pathname));
  let request,sequence=0;
  const loadScript=source=>new Promise((resolve,reject)=>{
    const url=new URL(source.src,location.href);
    if(loadedScripts.has(url.pathname)){resolve();return;}
    const script=document.createElement('script');script.src=url.href;script.async=false;
    script.onload=()=>{loadedScripts.add(url.pathname);resolve();};
    script.onerror=()=>{script.remove();reject(Error('script'));};document.head.append(script);
  });
  const loadStyle=source=>new Promise((resolve,reject)=>{
    const href=new URL(source.getAttribute('href'),location.href).href;
    if([...document.head.querySelectorAll('link[rel=stylesheet]')].some(link=>link.href===href)){resolve();return;}
    const link=document.createElement('link');link.rel='stylesheet';link.href=href;
    link.onload=resolve;link.onerror=()=>{link.remove();reject(Error('style'));};document.head.append(link);
  });
  function feedback(main,tabs,url){
    let note=main.querySelector('[data-rb-navigation-message]');
    if(!note){note=document.createElement('p');note.className='nrb-navigation-message';note.dataset.rbNavigationMessage='';note.setAttribute('role','alert');tabs.after(note);}
    note.replaceChildren(document.createTextNode(tabs.dataset.navigationError||'This collection could not be loaded. Please try again. '));
    const link=document.createElement('a');link.href=url.href;link.textContent=tabs.querySelector('a[href*="nana-'+view(url)+'"]')?.textContent.trim()||'Open collection';note.append(' ',link);note.hidden=false;
  }
  async function navigate(url,{pop=false,restoreY}={}){
    const main=document.getElementById('MainContent'),tabs=main?.querySelector('.nrb-tabs'),banner=main?.querySelector('[data-rb-banner]');
    if(!main||!tabs||!banner)return;
    const own=++sequence;request?.abort();request=new AbortController();tabs.setAttribute('aria-busy','true');
    const oldY=scrollY,tabTop=tabs.getBoundingClientRect().top;
    try{
      const response=await fetch(url.href,{credentials:'same-origin',signal:request.signal});
      if(!response.ok)throw Error('response');
      const doc=new DOMParser().parseFromString(await response.text(),'text/html');
      const incoming=doc.getElementById('MainContent'),nextTabs=incoming?.querySelector('.nrb-tabs'),nextBanner=incoming?.querySelector('[data-rb-banner]');
      if(!incoming||!nextTabs||!nextBanner)throw Error('markup');
      await Promise.all([...incoming.querySelectorAll('link[rel=stylesheet]')].map(loadStyle));
      const registry=[...incoming.querySelectorAll('script:not([src])')].find(s=>s.textContent.includes('window.NanaRecipePhotoRegistry=Object.assign'));
      if(registry&&!window.NanaRecipePhotoRegistry){const script=document.createElement('script');script.textContent=registry.textContent;document.head.append(script);script.remove();}
      const scripts=[...incoming.querySelectorAll('script[src]')].filter(s=>['nana-recipe-box.js','nana-specialty-editorial.js','nana-specialty-recipes.js','nana-family-recipes.js'].includes(new URL(s.getAttribute('src'),url).pathname.split('/').pop()));
      scripts.sort((a,b)=>Number(!a.src.includes('specialty-editorial'))-Number(!b.src.includes('specialty-editorial')));
      for(const script of scripts)await loadScript(script);
      if(own!==sequence)return;
      incoming.querySelectorAll('link[rel=stylesheet]').forEach(link=>link.remove());
      if(!pop){history.replaceState({...history.state,nrbScroll:oldY},'',location.href);history.pushState({nrbScroll:oldY},'',url);}
      banner.replaceChildren(...[...nextBanner.childNodes].map(node=>document.importNode(node,true)));
      nextBanner.replaceWith(banner);
      const active=view(url);
      tabs.querySelectorAll('a').forEach(link=>{if(view(new URL(link.href,location.href))===active)link.setAttribute('aria-current','page');else link.removeAttribute('aria-current');});
      nextTabs.replaceWith(tabs);
      main.replaceChildren(...[...incoming.childNodes].map(node=>document.adoptNode(node)));
      document.title=doc.title;
      window.NanaSpecialtyUI?.();window.NanaFamilyUI?.();window.NanaRecipeBox?.boot();
      const activeLink=tabs.querySelector('[aria-current=page]');activeLink?.focus({preventScroll:true});
      await new Promise(resolve=>requestAnimationFrame(()=>requestAnimationFrame(resolve)));
      if(own!==sequence)return;
      const y=pop&&Number.isFinite(restoreY)?restoreY:scrollY+tabs.getBoundingClientRect().top-tabTop;
      window.scrollTo({top:y,left:0,behavior:'instant'});
      document.dispatchEvent(new CustomEvent('nana:collection-changed',{detail:{collection:view(url)}}));
    }catch(error){if(error.name!=='AbortError'&&own===sequence){if(pop)location.reload();else feedback(main,tabs,url);}}
    finally{if(own===sequence)tabs.removeAttribute('aria-busy');}
  }
  document.addEventListener('click',event=>{
    const link=event.target.closest?.('.nrb-tabs a[href]');
    if(!link||event.button!==0||event.metaKey||event.ctrlKey||event.altKey||event.shiftKey||link.target==='_blank'||window.Shopify?.designMode)return;
    const url=new URL(window.NanaPreviewNavigation?.url(link.href)||link.href,location.href);
    if(url.origin!==location.origin||!view(url))return;
    const preview=new URL(location.href).searchParams.get('preview_theme_id');if(preview)url.searchParams.set('preview_theme_id',preview);
    event.preventDefault();
    if(view(url)===document.querySelector('.nana-recipe-box')?.dataset.rbCollection)return;
    navigate(url);
  });
  window.addEventListener('popstate',event=>{
    const url=new URL(location.href);
    if(document.querySelector('.nrb-tabs')&&view(url))navigate(url,{pop:true,restoreY:event.state?.nrbScroll});
  });
})();
